import { Flex } from '@withjoy/joykit';
import React from 'react';
// import { mockPageContainers } from './mocks.constants';
import { HotelTileList } from '../../components/Hotel';
import { HotelMap } from '../../components/Hotel/HotelMap';
interface Props {
  pageId: string;
  eventId: string;
}

export const Custom: React.FC<Props> = ({ pageId, eventId }) => {
  // Custom widget will query for [ReservedRoomBlocks], pass to presentational child as hotelTileListData list

  return (
    <Flex flexDirection={'column'} justifyContent={'center'} alignItems={'center'} width={'100%'}>
      <HotelMap />
      <HotelTileList
        hotelTileListData={[
          { foo: 'foo', bar: 'bar' },
          { foo: 'foo', bar: 'bar' }
        ]}
      />
    </Flex>
  );
};
